import { createContext, ReactNode, useState } from 'react';

type DataStateObject = {
	sc: string | null;
};

const defaultDataState: DataStateObject = {
	sc: null,
};

export const DataContext = createContext<DataStateObject>(defaultDataState);

type IDataContextProps = {
	children: ReactNode;
};

const DataProvider = (props: IDataContextProps) => {
	const [sc] = useState<string | null>(null); // Unique code for shortened URL

	return (
		<DataContext.Provider
			value={{
				sc,
			}}>
			{props.children}
		</DataContext.Provider>
	);
};

export default DataProvider;
